"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    animation: Boolean | Object,
    autoBind: Boolean,
    contentUrls: Array,
    dataImageUrlField: String,
    dataSource: Object | Array | kendo.data.HierarchicalDataSource,
    dataSpriteCssClassField: String,
    dataTextField: String | Array,
    dataUrlField: String,
    expandMode: String,
    loadOnDemand: Boolean,
    messages: Object,
    template: String | Function,

    // Events
    activate: Function,
    collapse: Function,
    contentLoad: Function,
    dataBound: Function,
    error: Function,
    expand: Function,
    select: Function
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-layout-vue-wrapper/dist/es/KendoPanelBar/PanelBarProps.js
// module id = 669
// module chunks = 0